export default __webpack_public_path__ + "static/media/dimg1.f1189219.jpg";